export default __webpack_public_path__ + "static/media/gm-pp-girl.2c77d703.webp";